<template>
  <span>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <b>{{$t("label.comments") + " (" + comments.length + ")"}}</b>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row dense align="center">
            <v-col cols="6">
              <v-text-field
                prepend-icon="mdi-message-reply-text"
                @focus="showSaveCancel"
                :placeholder="$t('component.caseReportComments.placeholder')"
                v-model="commentText"
              />
            </v-col>
            <v-col cols="4" v-show="saveCancelVisible">
              <v-btn
                small
                color="blue darken-1"
                :loading="loading"
                class="white--text"
                @click="onSave"
              >
                {{ $t("label.save") }}
              </v-btn>
              <v-btn small color="blue darken-1" text @click="onCancel">
                {{ $t("label.cancel") }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row dense align="center">
            <v-col>
              <span
                v-for="(comment, index) in comments"
                :key="'comment-' + index"
              >
                <v-row no-gutters align="center" class="mb-2">
                  <v-col cols="1">
                    <v-avatar color="purple" size="25">
                      <span class="white--text">
                        {{ getInitials(comment.userName) }}
                      </span>
                    </v-avatar>
                  </v-col>
                  <v-col>
                    <b class="mr-4">{{ comment.userName }}</b>
                    <span class=caption>{{ formatDateTime(comment.created) }}</span>
                    <br />
                    {{ comment.comment }}
                  </v-col>
                  <v-spacer />
                </v-row>
              </span>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <!-- </v-card-text>
    </v-card> -->
  </span>
</template>

<script>
import { getInitials } from "../utils/userUtils";
import { formatDateTime } from "../utils/dateUtils";
import { mapActions } from "vuex";
export default {
  name: "CaseReportComments",
  data() {
    return {
      loading: false,
      saveCancelVisible: false,
      commentText: null,
    };
  },
  props: {
    comments: {
      type: Array,
      default: () => [],
    },
    caseReportId: {},
  },
  methods: {
    ...mapActions(["setGlobalAlert", "saveComment"]),
    getInitials,
    formatDateTime,
    showSaveCancel() {
      this.saveCancelVisible = true;
    },
    onSave() {
      if(!this.commentText || this.commentText.trim().length === 0){
        return;
      }
      this.loading = true;
      this.saveComment({
        caseReportId: this.caseReportId,
        commentText: this.commentText,
      })
        .catch(() => {
          this.setGlobalAlert({
            alert: true,
            color: "red",
            alertTitle: "Oops.",
            alertMessage: this.$t("error.general.unhandled"),
          });
        })
        .then(() => {
          this.commentText = null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCancel() {
      this.saveCancelVisible = false;
      this.commentText = null;
    },
  },
};
</script>